/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrGlucose, PhrGlucoseFromJSON, PhrGlucoseFromJSONTyped, PhrGlucoseToJSON } from "./";

export const PhrGlucosesTypename = "PhrGlucoses" as const;

/**
 *
 * @export
 * @interface PhrGlucoses
 */
export interface PhrGlucoses {
  /**
   *
   * @type {PhrGlucose}
   * @memberof PhrGlucoses
   */
  casual?: PhrGlucose;
  /**
   *
   * @type {PhrGlucose}
   * @memberof PhrGlucoses
   */
  fasting?: PhrGlucose;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrGlucoses
   */
  readonly __typename?: string;
}

export function PhrGlucosesFromJSON(json: any): PhrGlucoses {
  return PhrGlucosesFromJSONTyped(json, false);
}

export function PhrGlucosesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrGlucoses {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrGlucosesTypename,

    casual: !exists(json, "casual") ? undefined : PhrGlucoseFromJSON(json["casual"]),
    fasting: !exists(json, "fasting") ? undefined : PhrGlucoseFromJSON(json["fasting"]),
  };
}

export function PhrGlucosesToJSON(object?: PhrGlucoses | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    casual: PhrGlucoseToJSON(value.casual),
    fasting: PhrGlucoseToJSON(value.fasting),
  };
}
